import { ISvgComponent } from '../../svg.models';
import * as S from '../svg.style';

export const Minus: React.FC<ISvgComponent> = ({ color, height, width, shrinkable, ...rest }) => (
  <S.Svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    shrinkable={shrinkable}
    {...rest}
  >
    <path stroke={color} strokeLinecap="round" strokeMiterlimit="10" d="M19.375 12H4.625" />
  </S.Svg>
);

